import { useState, type FormEvent } from "react";

interface ZipMetricStepProps {
  onSubmit: (zip: string) => void;
  onBack: () => void;
}

export function ZipMetricStep({ onSubmit, onBack }: ZipMetricStepProps) {
  const [zip, setZip] = useState("");
  const [error, setError] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const cleaned = zip.replace(/\D/g, "").slice(0, 5);
    if (cleaned.length !== 5) {
      setError("Enter a valid 5-digit US ZIP code.");
      return;
    }
    setError("");
    onSubmit(cleaned);
  }

  return (
    <div className="animate-fade-in p-4 sm:p-5">
      <div className="mb-4 border-l-2 border-emerald-600 pl-3">
        <p className="text-[10px] font-bold uppercase tracking-widest text-emerald-700">Metric 2</p>
        <h2 className="text-base font-semibold text-slate-900">Geographic Rate Multiplier</h2>
        <p className="mt-0.5 text-xs text-slate-500">
          Adjust estimate based on local labor rates and regional pest activity data.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="zip" className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-600">
            5-Digit US ZIP Code
          </label>
          <input
            id="zip"
            type="text"
            inputMode="numeric"
            maxLength={5}
            placeholder="Enter ZIP"
            value={zip}
            onChange={e => {
              setZip(e.target.value.replace(/\D/g, "").slice(0, 5));
              if (error) setError("");
            }}
            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-center font-mono text-xl tracking-widest text-slate-900 placeholder:text-slate-300 placeholder:tracking-normal focus:border-emerald-600 focus:outline-none focus:ring-1 focus:ring-emerald-600"
            autoComplete="postal-code"
          />
          {error && <p className="mt-2 text-xs text-red-600">{error}</p>}
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={onBack}
            className="rounded-lg border border-slate-200 px-4 py-3 text-sm font-medium text-slate-600 hover:bg-slate-50"
          >
            Back
          </button>
          <button
            type="submit"
            className="flex-1 rounded-lg bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
          >
            Continue to Diagnostic
          </button>
        </div>
      </form>
    </div>
  );
}
